import Checkbox from './Checkbox';
import Group from './Group';
Checkbox.Group = Group;
export default Checkbox;


//////////////////
// WEBPACK FOOTER
// ./node_modules/.3.6.1@antd/es/checkbox/index.js
// module id = 75
// module chunks = 1